import { Component, Input } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'apc-batch-summary',
    templateUrl: './batch-summary.component.html',
    styleUrls: ['./batch-summary.component.scss'],
    standalone: false
})
export class BatchSummaryComponent {
  @Input() modalRef: NgbModalRef;
  errors:any = [];
  successes:any = [];
  constructor(private readonly modalService: NgbModal) {}

  close() {
    this.modalService.dismissAll();
  }
}
